// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./radio.png");
var dir = previousRequest.replace("radio.png", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "radio.png",
	name: "radio",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/join/radio.png
// module id = 1068
// module chunks = 4